import { createSlice } from "@reduxjs/toolkit";

export interface UserIp {
  userIp: string;
}

const initialState: UserIp = {
  userIp: "",
};

export const userIpSlice = createSlice({
  name: "userIp",
  initialState,
  reducers: {
    setUserIp: (state, action) => {
      state.userIp = action.payload;
    },
  },
});

export const { setUserIp } = userIpSlice.actions;

export default userIpSlice.reducer;
